import { useTranslation } from 'react-i18next';
import Tooltip from 'components/tooltip/Tooltip';
import { Row } from '@tanstack/react-table';
import { ICal } from 'models/ICal';
import useMutationsIcals from '../../useMutationsIcals';
import {
  SyncNowIcon,
  RemoveIcon,
  ActionsCellContainer,
} from './ActionsCell.styles';

const ActionsCell = ({ row }: { row: Row<ICal> }) => {
  const { removeIcal, synchronizeIcal } = useMutationsIcals();
  const { t } = useTranslation();

  return (
    <ActionsCellContainer>
      <Tooltip
        text={t('pageAutomations.calendarTools.calendarImportSection.syncNow')}
        id="sync-now-ical-tooltip"
      >
        <SyncNowIcon
          data-testid="sync-ical-button"
          onClick={() => synchronizeIcal(row.original.uid!)}
        />
      </Tooltip>
      <Tooltip text={t('common.remove')} id="remove-ical-tooltip">
        <RemoveIcon
          data-testid="remove-ical-button"
          onClick={() => removeIcal(row.original.uid!)}
        />
      </Tooltip>
    </ActionsCellContainer>
  );
};

export default ActionsCell;
